import { DEFAULT_DATE_FORMAT } from 'common/constant/constant';
import { parseISO as parseDate, format as formatDate } from 'date-fns';

const DateTimeCell = ({ value }: { value: string }): JSX.Element => {
    if (!value) return <></>;

    const date = parseDate(value);
    return <>{formatDate(date, DEFAULT_DATE_FORMAT)}</>;
};

export default DateTimeCell;
